export const DATE_SURVEY_TYPE = 'date';
export const NUMBER_SURVEY_TYPE = 'number';
export const TEXT_SURVEY_TYPE = 'text';
export const MULTI_SELECT_SURVEY_TYPE = 'multiple_select'; // checkbox
export const MULTI_CHOICE_SURVEY_TYPE = 'multiple_choice'; // radio
export const HEIGHT_SURVEY_TYPE = 'height';

export const SUB_AND_DEP_TYPE = 'Subscriber and dependents';
export const SUB_ONLY_TYPE = 'Subscriber';
export const DEP_ONLY_TYPE = 'Dependent Only';
